import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,filter_fn} from '../utils.js'
import UniTable from '../cmp/UniTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

let findDlg=false

function CatEmployeesList({data=undefined,actions,choice=false}){

    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    if(wndData!==''&&wndData.ierarc===undefined) wndData.ierarc=1

    const context=useContext(dataContext)
    const Data=context.data['catEmployees']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const getSettings=context.getSettings
    const setSettings=context.setSettings
    const usersettings=getSettings()
    const inputCols=context.inputCols
    //const setLoginData=context.setLoginData
    const glStatus=context.status
    let hiden=true
    if(wndData.hiden!==undefined) hiden=wndData.hiden
    const setHiden=d=>setWndData({...wndData,hiden:d})

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'catEmp',sortable:false},
        {caption:'id',minWidth:'15',dataId:'id',sortable:true},
        {caption:localestr('ПІБ'),minWidth:'140',dataId:'name',sortable:true},
        {caption:localestr('Відпрацьовано'),minWidth:'32',dataId:'sum_worked',sortable:true},
        {caption:localestr('Бейджик'),minWidth:'32',dataId:'code',sortable:true},
        {caption:localestr('Прийнятий'),minWidth:'32',dataId:'start',sortable:true},
        {caption:localestr('Звільнений'),minWidth:'32',dataId:'finish',sortable:true},
        {caption:localestr('Посада'),minWidth:'52',dataId:'position',sortable:true},
        {caption:localestr('Підрозділ'),minWidth:'52',dataId:'department',sortable:true},
        {caption:localestr('Оклад'),minWidth:'32',dataId:'sum_m',sortable:true},
        {caption:localestr('Поденно'),minWidth:'32',dataId:'sum_d',sortable:true},
        {caption:localestr('Погодинно'),minWidth:'32',dataId:'sum_h',sortable:true},
        {caption:localestr('%'),minWidth:'32',maxWidth:'75',dataId:'prc_a',sortable:true},
        {caption:localestr('Підрозділ'),minWidth:'32',dataId:'department1',sortable:true},
        {caption:localestr('%'),minWidth:'32',maxWidth:'75',dataId:'prc_d1',sortable:true},
        {caption:localestr('Підрозділ'),minWidth:'32',dataId:'department2',sortable:true},
        {caption:localestr('%'),minWidth:'32',maxWidth:'75',dataId:'prc_d2',sortable:true},
        {caption:localestr('Загально %'),minWidth:'32',maxWidth:'75',dataId:'prc_t',sortable:true},
        {caption:localestr('Податки'),minWidth:'45',dataId:'taxes',typeCol:'check'},
    ]

    if(usersettings.CatEmployeesList&&usersettings.CatEmployeesList.cols){
        for(let i=0;i<usersettings.CatEmployeesList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatEmployeesList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    }

    const filterData=[ //+
        {caption:'№',dataId:'id',typeVal:'text'},
        {caption:localestr('ПІБ'),dataId:'name',typeVal:'text'},
        {caption:localestr('Відпрацьовано'),dataId:'sum_worked',typeVal:'text'},
        {caption:localestr('Бейджик'),dataId:'code',typeVal:'text'},
        {caption:localestr('Прийнятий'),dataId:'start',typeVal:'date'},
        {caption:localestr('Звільнений'),dataId:'finish',typeVal:'date'},
        {caption:localestr('Посада'),dataId:'position',typeVal:'catPositions'},
        {caption:localestr('Підрозділ'),dataId:'department',typeVal:'catDepartments'},
        {caption:localestr('Оклад'),dataId:'sum_m',typeVal:'number'},
        {caption:localestr('Поденно'),dataId:'sum_d',typeVal:'number'},
        {caption:localestr('Погодинно'),dataId:'sum_h',typeVal:'number'},
        {caption:localestr('% користувача'),dataId:'prc_a',typeVal:'number'},
        {caption:localestr('Підрозділ 1'),dataId:'department1',typeVal:'catDepartments'},
        {caption:localestr('%'),dataId:'prc_d1',typeVal:'number'},
        {caption:localestr('Підрозділ 2'),dataId:'department2',typeVal:'catDepartments'},
        {caption:localestr('%'),dataId:'prc_d2',typeVal:'number'},
        {caption:localestr('Загально %'),dataId:'prc_t',typeVal:'number'},
        {caption:localestr('Податки'),dataId:'taxes',typeVal:'selYN'},
        {caption:localestr('База для податків'),dataId:'tax_base',typeVal:'number'},
        {caption:localestr('Податки на витрати'),dataId:'expenses',typeVal:'selYN'},
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        let ierarc=1
        if(showAFilter) ierarc=0
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(!showAFilter) setWndData({...wndData,ierarc,filter:undefined,showAFilter})
        else setWndData({...wndData,ierarc,showAFilter})
    }

    function time_to_str(d){
        let t=parseInt(d||0)||0
        if(!t) return ''
        let hr=parseInt(t/60)
        let mn=t-hr*60
        if(hr>99) return ''+hr+':'+('00'+mn).slice(-2)
        return ('00'+hr).slice(-2)+':'+('00'+mn).slice(-2)
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item}
            newItem.sum_worked=time_to_str(newItem.worked)
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({CatEmployeesList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const after_save=(d)=>{
        if(!d) return
        const currentCol={}
        currentCol.id=''+d.id
        if(d.isfolder) currentCol.isfolder=true
        wndData=actions.getWndData()
        //let currentFld=wndData.currentFld
        //if(d.parent) currentFld=DataFld.find(el=>el.id===d.parent.id)
        if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
        //console.log({...wndData,currentCol,currentFld})
        setTimeout(()=>{setWndData({...wndData,currentCol});setGlData({needFocus:0})},10)
        //setTimeout(()=>setWndData({...wndData,currentCol,currentFld}),200)
        updateData('catEmployees')
        //loadData()
    }

    const newItem=()=>{tabNew('catEmployees_edit',localestr('Працівник')+' *',{start:(new Date()),update:after_save})}

    const editItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('catEmployees_edit',localestr('Працівник')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,update:after_save})
            //console.log(wndData.currentCol)
        }
    }

    const copyItem=()=>{
        let item={...wndData.currentCol,update:after_save}
        delete item.id
        if (typeof wndData.currentCol === 'object') {
            tabNew('catEmployees_edit',localestr('Працівник')+' *',item)
            //console.log(wndData.currentCol)
        }
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice===2) {tabChoice(wndData.currentCol)}
            else if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }

    const getNextItem=(i,d)=>{
        if(d>0) for(let idx=i+1;idx<wndData.list.length;idx++) if(!parseInt(wndData.list[idx].marked)) return ({...wndData.list[idx]})
        else for(let idx=i-1;idx>=0;idx--) if(!parseInt(wndData.list[idx].marked)) return ({...wndData.list[idx]})

        return undefined
    }

    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            const idx=wndData.list.findIndex(el=>el.id===wndData.currentCol.id)
            let item=undefined
            if(hiden&&idx+1>=wndData.list.length&&idx>0) item=getNextItem(idx,-1)
            else if(hiden&&idx>0) item=getNextItem(idx,1)
            else if(idx!==-1) item={...wndData.list[idx]}
            let newData={status:'rem',key:'CatEmployees',data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='1'?'0':'1')}}
            saveData(newData,()=>{setWndData({...wndData,currentCol:item})})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:'catEmployees'}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:'catEmployees'}},true)
        }
    }

    const grpEdit=()=>{
        let list=[...wndData.list||[]]
        list=list.filter(el=>filter_fn(el,wndData.filter))
        list=list.map(el=>{return{...el,checked:true}})
        const fields=[
            {caption:localestr('Назва'),minWidth:'160',dataId:'name'},
            {caption:localestr('Оклад'),minWidth:'32',dataId:'sum_m',typeVal:'number'},
            {caption:localestr('Поденно'),minWidth:'32',dataId:'sum_d',typeVal:'number'},
            {caption:localestr('%'),minWidth:'32',dataId:'prc_a',typeVal:'number'},
            {caption:localestr('Підрозділ'),minWidth:'32',dataId:'department1',typeVal:'catDepartments'},
            {caption:localestr('%'),minWidth:'32',dataId:'prc_d1',typeVal:'number'},
            {caption:localestr('Підрозділ'),minWidth:'32',dataId:'department2',typeVal:'catDepartments'},
            {caption:localestr('%'),minWidth:'32',dataId:'prc_d2',typeVal:'number'},
            {caption:localestr('Податки'),minWidth:'32',dataId:'taxes',typeVal:'selYN'},
            {caption:localestr('База для податків'),minWidth:'32',dataId:'tax_base',typeVal:'number'},
            {caption:localestr('Податки на витрати'),minWidth:'32',dataId:'expenses',typeVal:'selYN'},
        ]
        tabNew('serv_grp_edit',localestr('Групова зміна посад'),{dataType:'catPositions',list,fields,checked:true})
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData('catEmployees')
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data])
    
    let wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    if(hiden) wndDataList=wndDataList.filter(item=>!parseInt(item.marked))
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData('catEmployees')}},
        {name:localestr('Групова зміна'),icon:'#hisBut',action:grpEdit},
    ]
    if(hiden) menuData.push({name:localestr('Показати видалені'),icon:'#remBut',action:()=>setHiden(false)})
    if(!hiden) menuData.push({name:localestr('Сховати видалені'),icon:'#remBut',action:()=>setHiden(true)})
    if(choice) menuData.splice(2,3)

    const findItem=(val)=>{
        const newData={...wndData,findText:val}
        findDlg=false
        newData.findArr=null
        if (val.length>1){
            const Arr=wndData.list.filter(el=>(el.id.indexOf(val)===0||(el.name||'').toLowerCase().indexOf(val.toLowerCase())!==-1||(el.barcode&&el.barcode.indexOf(val)===0))&&!parseInt(el.marked))
            if(Arr.length>10) Arr.splice(10)
            newData.findArr=Arr
            if(Arr.length) findDlg=true
            else{newData.findArr=null;findDlg=false}
        }
        setWndData(newData)
    }

    const findClick=(el)=>{
        const wndData_=actions.getWndData()
        const newData={...wndData_,currentCol:{...el},findText:'',findArr:null}
        findDlg=false
        setWndData(newData)
        setGlData({needFocus:0})
    }

    let findItems=null
    if(findDlg&&wndData.findArr){
        setTimeout(()=>findDlg=false,30000)
        const items=wndData.findArr.map((el,idx)=>{
            let stl={cursor:'pointer',fontSize:'small'}
            return(
            <div key={idx} style={stl} onClick={()=>{findClick(el)}}>{el.id+' - '+el.name}</div>
        )})
        findItems=<div className='no-print' style={{right:'0px',top:'24px',width:'100%',position:'absolute',background:'#FFFFFF',zIndex:'100'}}>
            {items}
        </div>
    }

    return(
        <>
        
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={editItem} onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}
            ><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={removeItem} onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}
            ><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}} onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}
            ><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div style={{position:'relative',padding:'3px'}}>
                <input id='search' type='text' value={wndData.findText||''} onChange={(e)=>{findItem(e.target.value)}} 
                    onBlur={()=>{setTimeout(()=>{if(findDlg) setWndData({...wndData,findArr:null,currFind:undefined})},200)}} placeholder={localestr('пошук')} 
                    style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'7px',top:'9px',width:'14px',height:'14px',opacity:0.5}}/>
                {findItems}
            </div>
            <div style={{flexGrow:'10'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatEmployeesList